import { styled } from '@material-ui/core';

export const Wrapper = styled('div')({});
